import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import moment from 'moment'
import { Grid, TextField } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'

import constants from 'constants/index'

const DynamicField = ({ field, isShow, index }) => {
  const { TEXT_FIELD_TYPE, DATE_FIELD_TYPE } = constants.assetInventory

  const { control, errors } = useFormContext()

  const isMultiline = field?.fieldType === TEXT_FIELD_TYPE
  const isDateType = field?.fieldType === DATE_FIELD_TYPE

  return (
    <Grid item xs={12} key={field.id}>
      {isDateType ? (
        <Controller
          control={control}
          mode="onChange"
          name={`categoryFields[${index}].answer`}
          defaultValue={null}
          rules={{
            validate: {
              required: (value) => {
                if (!!field?.required && !value) {
                  return 'Preencha esse campo'
                }

                return true
              },
              validDate: (value) => {
                if (!field?.required && !value) return true
                if (!moment(value).isValid()) {
                  return 'Preencha esse campo de forma válida'
                }

                return true
              },
            },
          }}
          as={
            <KeyboardDatePicker
              label={field.name}
              inputVariant="outlined"
              format="DD/MM/yyyy"
              error={!!errors?.categoryFields?.[index]?.answer}
              helperText={errors?.categoryFields?.[index]?.answer?.message}
              onChange={(newValue) => ({ value: newValue })}
              invalidDateMessage="Data inválida"
              disabled={isShow}
              required={!!field?.required}
              fullWidth
            />
          }
        />
      ) : (
        <Controller
          control={control}
          mode="onChange"
          name={`categoryFields[${index}].answer`}
          defaultValue=""
          rules={{
            required: {
              message: 'Preencha esse campo',
              answer: !!field?.required,
            },
            maxLength: {
              answer: isMultiline ? 5000 : 255,
              message: `Deve ter no máximo ${
                isMultiline ? 5000 : 255
              } caracteres`,
            },
          }}
          as={
            <TextField
              label={field.name}
              error={!!errors?.categoryFields?.[index]?.answer}
              helperText={errors?.categoryFields?.[index]?.answer?.message}
              fullWidth
              required={!!field?.required}
              disabled={isShow}
              {...(isMultiline && {
                multiline: isMultiline,
                minRows: 6,
                maxRows: 12,
              })}
            />
          }
        />
      )}
    </Grid>
  )
}

export default DynamicField
